import { useEffect, useState } from "react";
import { Text, Button, Card, Input, Divider, Loading } from "@nextui-org/react";
import AddModal from "../components/AddModal";
import { Fragment } from "react";
import {
  AiFillCloseCircle,
  AiOutlineArrowLeft,
  AiOutlineSave,
  AiOutlinePlus,
  AiFillEdit,
} from "react-icons/ai";
import useInput from "../hooks/useInput";
import { useNavigate, useParams } from "react-router-dom";

import "./Home.css";

const EditOrder = (props) => {
  const navigate = useNavigate();

  const params = useParams();
  const id = params.id;

  const [prods, setProds] = useState([]);
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [date, setDate] = useState(new Date().toISOString().substring(0, 10));
  const [error, isError] = useState(false);
  const [edit, setEdit] = useState(null);

  const {
    inputValue: nameValue,
    error: nameError,
    isValid: nameValid,
    inputHandler: nameHandler,
    blurHandler: nameBlur,
    clearInput: clearName,
    setInputValue: setName,
  } = useInput((value) => value !== "");

  const {
    inputValue: otpValue,
    error: otpError,
    isValid: otpValid,
    inputHandler: otpHandler,
    blurHandler: otpBlur,
    clearInput: clearOTP,
  } = useInput((value) => value === "788983");

  const fetchData = async () => {
    setLoading(true);
    fetch(`https://sca-token-api.vercel.app/order/${id}`)
      .then((res) => {
        if (!res.ok) {
          throw new Error("Error occured while trying to fetch!");
        }
        return res.json();
      })
      .then((dta) => {
        console.log(dta);
        setName(dta?.name);
        setDate(dta?.date?.substring(0, 10));
        setProducts(dta?.products);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  const addToProduct = (data) => {
    const newProd = [...products, data];
    return setProducts(newProd);
  };

  const editToProduct = (data, _id) => {
    let copy = [...products];
    const dataIndex = copy.findIndex(
      (doc) => doc._id?.toString() === _id?.toString()
    );

    if (dataIndex >= 0) {
      copy[dataIndex].category = data?.category;
      copy[dataIndex].codes = data?.codes;
      copy[dataIndex].details = data?.details;
      copy[dataIndex].name = data?.name;
      copy[dataIndex].price = data?.price;
      copy[dataIndex].warranty = data?.warranty ?? "";
    }

    setProducts(copy);
    setEdit(null);
  };

  const removeProduct = (index) => {
    const newProd = [...products];
    let splicedProd = newProd.filter((doc, i) => {
      return index !== i;
    });
    return setProducts(splicedProd);
  };

  useEffect(() => {
    fetch("https://sca-token-api.vercel.app/get-products")
      .then((res) => res.json())
      .then((data) => {
        if (data?.success) {
          setProds({
            iphones: data?.iphones,
            ipods: data?.ipods,
            iwatches: data?.iwatches,
          });
        }
      });
  }, []);

  const submitHandler = () => {
    console.log("form submittted");
    if (!nameValid || !otpValid || products.length == 0) {
      return;
    }

    const orderData = {
      name: nameValue,
      date: date,
      products: products,
      _id: id,
    };
    isError(false);
    setLoading(true);
    fetch("https://sca-token-api.vercel.app/order/edit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(orderData),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error("There was an error while posting the order.");
        }
        props.triggerUpdate();
        setLoading(false);
        return navigate(`/orders/${id}`);
      })
      .catch((err) => {
        isError(true);
        setLoading(false);
      });
  };

  return (
    <Fragment>
      <div className="header">
        <Text b>EDIT ORDER</Text>
        <div className="newOrderAction">
          <Button auto flat rounded size="sm" onClick={() => navigate("/")}>
            <AiOutlineArrowLeft />
          </Button>
          <Button
            auto
            size="sm"
            color="success"
            rounded
            onClick={submitHandler}
            disabled={nameValid && products.length > 0 ? false : true}
          >
            {loading ? (
              <Loading type="spinner" />
            ) : (
              <Fragment>
                <AiOutlineSave /> Save
              </Fragment>
            )}
          </Button>
        </div>
      </div>
      <div className="orderDetails">
        <Card
          variant="flat"
          css={{
            mw: "550px",
            px: "10px",
            py: "20px",
            textAlign: "start",
          }}
          className="newOrderForm cardShadow"
        >
          {error && (
            <Text
              css={{
                br: "20px",
                py: "5px",
                px: "10px",
                bgColor: "$red100",
                textAlign: "center",
              }}
              color="$red700"
              size="14px"
            >
              An error occured while trying to post! please try again.
            </Text>
          )}
          <Input
            label={nameError ? "Party Name Required *" : "Party Name"}
            type="text"
            placeholder="Party Name"
            css={{ w: "100%" }}
            bordered
            value={nameValue}
            onChange={nameHandler}
            onBlur={nameBlur}
            color={nameError ? "error" : "default"}
            aria-label="Party Name"
          />
          <Input
            label={otpError ? "Edit Code Required *" : "OTP"}
            type="text"
            placeholder="OTP"
            css={{ w: "100%" }}
            bordered
            value={otpValue}
            onChange={otpHandler}
            onBlur={otpBlur}
            color={otpError ? "error" : "default"}
            aria-label="OTP"
          />
          <Input
            bordered
            type="date"
            label="Order Date"
            value={date}
            onChange={(event) => setDate(event.target.value)}
            aria-label="Order Date"
          />
          <Button
            auto
            color="secondary"
            css={{ w: "fit-content", alignSelf: "flex-end" }}
            size="sm"
            onClick={() => setVisible(!visible)}
            rounded
          >
            <AiOutlinePlus />
            Add a Product
          </Button>

          {products.length > 0 && (
            <Fragment>
              <Divider />
              <div className="addedProducts">
                <Text h4>Products</Text>
                {products.length > 0 &&
                  products.map((doc, index) => {
                    return (
                      <div key={index} className="imeis">
                        <Text b size="14px">
                          {doc.name} ({doc.codes.length})
                        </Text>
                        <div style={{ display: "flex", gap: 12 }}>
                          <Button
                            auto
                            size="xs"
                            flat
                            color="success"
                            onClick={() => {
                              setEdit(doc);
                              setVisible(true);
                            }}
                          >
                            <AiFillEdit />
                          </Button>
                          <Button
                            auto
                            size="xs"
                            flat
                            color="error"
                            onClick={() => removeProduct(index)}
                          >
                            <AiFillCloseCircle />
                          </Button>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </Fragment>
          )}
        </Card>
      </div>
      <AddModal
        addToProduct={addToProduct}
        editToProduct={editToProduct}
        visible={visible}
        closeHandler={() => setVisible(false)}
        prods={prods}
        isEdit={edit}
      />
    </Fragment>
  );
};

export default EditOrder;
